import React, { useEffect } from 'react';
import { useDropzone } from 'react-dropzone';

function ImagePicker(props) {
    const { onDrop, onRemove, files } = props;

    const { getRootProps, getInputProps } = useDropzone({
        accept: {
            'image/*': ['.png'],
        },
        maxFiles: 1,
        onDrop,
    });

    const thumbs = files.map((file) => (
        <div className="thumb" key={file.name}>
            <div className="thumb-inner">
                <img
                    src={file.preview}
                    className="thumb-img"
                    onLoad={() => {
                        URL.revokeObjectURL(file.preview);
                    }}
                />
                <button
                    className="close-button image"
                    onClick={(e) => {
                        e.preventDefault();
                        onRemove(file);
                    }}
                >
                				<svg
						width="16"
						height="16"
						viewBox="0 0 16 16"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M15 15L1 1"
							stroke="white"
							strokeWidth="1.5"
							strokeLinecap="round"
						/>
						<path
							d="M1 15L15 1"
							stroke="white"
							strokeWidth="1.5"
							strokeLinecap="round"
						/>
					</svg>
                </button>
            </div>
        </div>
    ));

    useEffect(() => {
        return () => files.forEach((file) => URL.revokeObjectURL(file.preview));
    }, []);

    return (
        <section className="image-picker-container">
            {thumbs.length == 0 && (
                <div
                    {...getRootProps({ className: 'dropzone' })}
                >
                    <input {...getInputProps()} />
                    <p>
                        Kliknite ovdje za odabir datoteke loga ili ispustite
                        datoteku na označeno područje.
                    </p>
                </div>
            )}
            <aside className="thumbs-container">{thumbs}</aside>
        </section>
    );
}

export default ImagePicker;